<template>
	<div class="pt-2">
		<CommonFlame :title="'精錬入力'">
			<v-row no-gutters align="center">
				<v-btn
					color="secondary"
					@click="startRequiredTime"
					class="mt-4 mr-2"
					:disabled="!availableToStart"
				>
					<v-icon class="mr-1">mdi-timer-edit-outline</v-icon>
					開始 / 再開
				</v-btn>
				<v-btn
					color="red"
					@click="stopRequiredTime"
					class="mt-4 mr-2 white--text"
					:disabled="!availableToStop"
				>
					<v-icon class="mr-1">mdi-timer-off-outline</v-icon>
					中断
				</v-btn>
				<v-btn
					color="secondary"
					@click="completeProcess"
					class="mt-4 mr-2"
					:disabled="!availableToComplete"
				>
					<v-icon class="mr-1">mdi-check</v-icon>
					完了
				</v-btn>
			</v-row>

			<v-divider class="my-4" />

			<v-sheet elevation="0" class="mt-4">
				<table width="100%" class="mt-2 show-dialog-table">
					<tbody>
						<ShowDetailRecord
							:tdStyle="{ padding: '4px' }"
							:columnName="'精錬対象'"
							:value="rubber_process.main_deliverable.target.name"
						/>
						<!-- TODO 紐付くRequirementの納期 -->
						<ShowDetailRecord
							:tdStyle="{ padding: '4px' }"
							:columnName="'納期'"
							:value="'2023年4月21日(金)'"
						/>
						<ShowDetailRecord
							:tdStyle="{ padding: '4px' }"
							:columnName="'数量'"
							:value="rubber_process.required_amount"
						/>
						<ShowDetailRecord :tdStyle="{ padding: '4px' }" :columnName="'完成数量'">
							<template v-slot:value>
								<v-form ref="form" v-model="valid">
									<v-text-field
										v-model="amount"
										:rules="[rules.required]"
										label="完成数量"
										outlined
										dense
										class="mt-4 append-outer"
									>
										<template v-slot:append-outer>
											<v-btn
												color="secondary"
												@click="submitForm"
												:disabled="!valid || status == 'completed'"
											>
												保存
											</v-btn>
										</template>
									</v-text-field>
								</v-form>
							</template>
						</ShowDetailRecord>
					</tbody>
				</table>
			</v-sheet>

			<div class="mt-4 table-container">
				<v-data-table
					locale="ja-JP"
					:items="rubber_process.rubber_process_sources"
					:headers="headers"
					:mobile-breakpoint="240"
					hide-default-footer
					disable-filtering
					disable-pagination
					disable-sort
					no-data-text="データがありません。"
				>
					<template v-slot:item="{ item }">
						<SourceRecord :source="item" :status="status" @update-source="updateSource($event)" />
					</template>
				</v-data-table>
			</div>
		</CommonFlame>
	</div>
</template>

<script>
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import common from "../../helper/common"
import rules from "../../helper/rules"
import CommonFlame from "../shared/CommonFlame.vue"
import ShowDetailRecord from "../shared/ShowDetailRecord.vue"
import SourceRecord from "./components/SourceRecord.vue"

export default {
	components: {
		CommonFlame,
		ShowDetailRecord,
		SourceRecord,
	},
	data() {
		return {
			id: this.$route.params.id,
			rubber_process: {
				main_deliverable: {
					target: {
						name: "",
					},
				},
				rubber_process_sources: [],
			},
			amount: 0,
			valid: false,
			authorized: false,
			common,
			headers: [
				{ text: "原材料名", value: "target.name", width: "200px" },
				{ text: "消費予定量", value: "planned_amount", width: "150px" },
				{ text: "消費量", value: "amount", width: "250px" },
			],
			rules,
			status: null,
		}
	},
	mounted() {
		this.fetchRubberProcess(true)
	},
	methods: {
		updateSource(rubber_process_source) {
			const target = this.rubber_process.rubber_process_sources.find(
				(item) => item.id == rubber_process_source.id
			)
			target.amount = rubber_process_source.amount
		},
		fetchRubberProcess(first_visit) {
			const headers = authenticate.setHeader()
			const params = { first_visit }
			const url = `/erp/v1/rubber_processes/${this.id}`
			axios
				.get(url, {
					params,
					headers,
				})
				.then((res) => {
					this.rubber_process = res.data.rubber_process
					this.amount = this.rubber_process.main_deliverable.amount
					this.status = res.data.status
					this.authorized = res.data.authorized
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		submitForm() {
			const headers = authenticate.setHeader()
			const params = { rubber_process_deliverable: { amount: this.amount } }
			const url = `/erp/v1/rubber_process_deliverables/${this.rubber_process.main_deliverable.id}`
			axios
				.put(url, params, {
					headers,
				})
				.then((res) => {
					this.amount = res.data.amount
					this.$store.dispatch("setFlash", {
						type: "notice",
						text: `完成数量を保存しました`,
					})
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		openCheckUnitsDialog() {
			this.checkUnitsDialog = true
		},
		completeProcess() {
			const headers = authenticate.setHeader()
			const params = { situation: "completed" }
			const url = `/erp/v1/rubber_processes/rubber_process_situations/${this.rubber_process.id}`
			axios
				.put(url, params, {
					headers,
				})
				.then((res) => {
					this.$store.dispatch("setFlash", {
						type: "notice",
						text: `${res.data.message}`,
					})
					this.status = res.data.status
					this.$router.push({ name: "rubber_process_user_show" })
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		startRequiredTime() {
			// ユーザーの作業時間の開始と工程が未開始なら、工程の開始
			let situation
			if (this.status == "requested") situation = "ongoing"
			if (this.status == "interruption") situation = "resume"

			const headers = authenticate.setHeader()
			const params = { situation: situation }

			const url = `/erp/v1/rubber_processes/rubber_process_situations/${this.rubber_process.id}`
			axios
				.put(url, params, {
					headers,
				})
				.then((res) => {
					this.$store.dispatch("setFlash", {
						type: "notice",
						text: `${res.data.message}`,
					})
					this.status = res.data.status
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		stopRequiredTime() {
			// ユーザーの作業時間の終了
			let situation = "interruption"
			const headers = authenticate.setHeader()
			const params = { situation: situation }
			const url = `/erp/v1/rubber_processes/rubber_process_situations/${this.rubber_process.id}`
			axios
				.put(url, params, {
					headers,
				})
				.then((res) => {
					this.$store.dispatch("setFlash", {
						type: "alert",
						text: `${res.data.message}`,
					})
					this.status = res.data.status
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
	},
	computed: {
		isSameQuantity() {
			return this.rubber_process.required_amount == this.amount
		},
		availableToStart() {
			return this.authorized && (this.status == "requested" || this.status == "interruption")
		},
		availableToStop() {
			return this.authorized && this.status == "ongoing"
		},
		availableToComplete() {
			return (
				this.authorized &&
				this.isSameQuantity &&
				(this.status == "ongoing" || this.status == "interruption" || this.status == "resume")
			)
		},
	},
}
</script>
